import React from 'react';
import Heading from '../Typography/Heading';
import SpecialText from '../Typography/SpecialText';

const CouncilRegulatorsBanner = ({ heading, className, children, headingClasses }) => {
  return (
    <>
      <div className="mt-32 w-full">
        <div className={`${className} w-full h-screen relative rounded-xl bg-no-repeat bg-center object-cover bg-cover`}> 
          <div className="w-full h-full text-center flex flex-col items-center justify-center">
            <Heading variant={"h1"} className={`${headingClasses} text-center`}>
              {heading}
            </Heading>
          </div>
        </div>
      </div>
    </>
  );
};

export default CouncilRegulatorsBanner; 